<db-loading-screen *ngIf="loading" [pageBlocker]="true" ></db-loading-screen>

<div *ngIf="!loading" [ngClass]="{'db-booster': !!fromBooster}">
  <db-informative-banner *ngIf="!demoUser && !!website?.domain_hash && (!imageOptimizerPlugin || !imageOptimizerPlugin?.paidVersionInstalled || !imageOptimizerPlugin?.active)"
                         (btnClicked)="enableImageOptimizerHandler()"
                         [title]="'text_informativeBannerIoTitle' | dbText" [features]="features"
                         [imgSrc]="'assets/images/backgrounds/io-feature-bg.png'">
  </db-informative-banner>

  <db-optimize-images [currentSubscription]="currentSubscription"
                      [ngClass]="{'disable-overlay': !demoUser && !!website?.domain_hash && (!imageOptimizerPlugin?.paidVersionInstalled || !imageOptimizerPlugin?.active)}">
  </db-optimize-images>
</div>
